export enum PAYMENT_STATUS {
  CLICKED = 0,
  SUCCESS = 1,
  ERROR = 2,
  CANCELLED = 3
};
